import { singleton } from "tsyringe";
import BaseAdminApi from "./BaseAdminApi";
import SubscriptionResponseResource from "common/resources/Subscription/SubscriptionResponseResource";
import SubscriptionAdminCreateRequestResource from "common/resources/Subscription/SubscriptionAdminCreateRequestResource";
import SubscriptionCorporationAdminCreateRequestResource from "common/resources/Subscription/SubscriptionCorporationAdminCreateRequestResource";
import ManualSubscriptionProductsRequestResource, { ManualSubscriptionProductAvailability } from "common/resources/Subscription/ManualSubscriptionProductsRequestResource";

@singleton()
export default class SubscriptionApi extends BaseAdminApi {
	private baseurl = `${this.apiUrl}/subscriptions`;

	public checkProductAvailability(resource: ManualSubscriptionProductsRequestResource) {
		return this.postRequest<ManualSubscriptionProductAvailability>(`${this.baseurl}/product-availability`, { ...resource });
	}

	public authorizeProducts(resource: ManualSubscriptionProductsRequestResource) {
		return this.postRequest<ManualSubscriptionProductAvailability>(`${this.baseurl}/authorize-products`, { ...resource });
	}

	public async validate(subscriptionId: string) {
		const url = `${this.baseurl}/${subscriptionId}/validate`;
		return this.putRequest<SubscriptionResponseResource>(url);
	}

	public async createValidated(resource: SubscriptionAdminCreateRequestResource, validationDate: Date) {
		const url = `${this.baseurl}/validated`;
		return this.postRequest<SubscriptionResponseResource>(url, { ...resource, validationDate });
	}

	public async createCorporationValidated(resource: SubscriptionCorporationAdminCreateRequestResource, validationDate: Date) {
		const url = `${this.baseurl}/corporation/validated`;
		return this.postRequest<SubscriptionResponseResource>(url, { ...resource, validationDate });
	}

	public async hasOngoingSignature(subscriptionId: string) {
		const url = `${this.baseurl}/${subscriptionId}/has-electronic-signature`;
		return this.getRequest<{ isValid: boolean }>(url);
	}

	public async sendLegalDocs(subscriptionId: string) {
		const url = `${this.baseurl}/${subscriptionId}/send-legal-docs`;
		return this.postRequest(url);
	}

	public async archive(subscriptionId: string): Promise<void> {
		const url = `${this.baseurl}/${subscriptionId}`;
		return this.deleteRequest(url);
	}

	public async createWithCreator(resource: SubscriptionAdminCreateRequestResource) {
		const url = `${this.baseurl}`;
		return this.postRequest<SubscriptionResponseResource>(url, { ...resource });
	}

	public async createCorporationWithCreator(resource: SubscriptionCorporationAdminCreateRequestResource) {
		const url = `${this.baseurl}/corporation`;
		return this.postRequest<SubscriptionResponseResource>(url, { ...resource });
	}
}
